<div i18n class="mat-body-2 yellow-50-bg m-0 py-4 px-6">Материалы</div>

<mat-divider></mat-divider>

<mat-table #tableMaterial [dataSource]="dataSourceMaterials" class="glance-matching-table">
  <!-- Original material name Column -->
  <ng-container matColumnDef="name">
    <mat-header-cell i18n *matHeaderCellDef>Материал из модели</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ formatOriginMaterial(item) }}
    </mat-cell>
  </ng-container>

  <!-- Original material thickness Column -->
  <ng-container matColumnDef="thickness">
    <mat-header-cell i18n *matHeaderCellDef>Толщина</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <p class="text-truncate">{{ item.materialThickness }}</p>
    </mat-cell>
  </ng-container>

  <!-- Linked material name Column -->
  <ng-container matColumnDef="link_name">
    <mat-header-cell i18n *matHeaderCellDef>Материал для производства</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.linkedMaterialName }}
    </mat-cell>
  </ng-container>

  <!-- Size Column -->
  <ng-container matColumnDef="size">
    <mat-header-cell i18n *matHeaderCellDef>Формат</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <p class="text-truncate">{{ item.height }}&times;{{ item.width }}</p>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="materialDisplayedColumns"></mat-header-row>
  <mat-row class="butt-replacement-row" *matRowDef="let item; columns: materialDisplayedColumns"> </mat-row>
</mat-table>

<ng-container *ngIf="dataSourceButts.data.length > 0">
  <div i18n class="mat-body-2 yellow-50-bg m-0 py-4 px-6">Облицовка</div>
  <mat-divider></mat-divider>
  <mat-table #tableButts [dataSource]="dataSourceButts" class="glance-matching-table">
    <!-- Original butt name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell i18n *matHeaderCellDef>Облицовка из модели</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ formatOriginMaterial(item) }}
      </mat-cell>
    </ng-container>

    <!-- Original material thickness Column -->
    <ng-container matColumnDef="thickness">
      <mat-header-cell i18n *matHeaderCellDef>Толщина</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <p class="text-truncate">{{ item.materialThickness }}</p>
      </mat-cell>
    </ng-container>

    <!-- Linked butt name Column -->
    <ng-container matColumnDef="link_name">
      <mat-header-cell i18n *matHeaderCellDef>Облицовка для производства</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item.linkedMaterialName }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="buttDisplayedColumns"></mat-header-row>
    <mat-row class="butt-replacement-row" *matRowDef="let item; columns: buttDisplayedColumns"> </mat-row>
  </mat-table>
</ng-container>

<ng-container *ngIf="dataSourceSlots.data.length > 0">
  <div i18n class="mat-body-2 yellow-50-bg m-0 py-4 px-6">Пазы</div>
  <mat-divider></mat-divider>
  <mat-table #tableSlots [dataSource]="dataSourceSlots" class="glance-matching-table">
    <!-- Original slot name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell i18n *matHeaderCellDef>Паз из модели</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ formatOriginMaterial(item) }}
      </mat-cell>
    </ng-container>

    <!-- Linked slot name Column -->
    <ng-container matColumnDef="link_name">
      <mat-header-cell i18n *matHeaderCellDef>Паз для производства</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item.linkedMaterialName }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="slotDisplayedColumns"></mat-header-row>
    <mat-row class="butt-replacement-row" *matRowDef="let item; columns: slotDisplayedColumns"> </mat-row>
  </mat-table>
</ng-container>
